import type { ErrorDescription } from 'types/handled_error';

export const labsHandledErrors: ErrorDescription[] = [
  {
    endpoint: 'labs/lab_trades',
    method: 'get',
    responseStatus: 498,
    error: 'invalid_token',
  },
  {
    endpoint: 'labs/trades/payment/pay_participations',
    method: 'post',
    responseStatus: 500,
  },
  {
    endpoint: 'labs/trades/payment/pay_participations',
    method: 'post',
    responseStatus: 400,
    error: 'lab_payment_onboarding_incomplete',
  },
  {
    endpoint: 'labs/trades/payment/pay_participations',
    method: 'post',
    responseStatus: 400,
    error: 'no_trade_instance_to_pay',
  },
  {
    endpoint: 'labs/trades/payment/pay_participations',
    method: 'post',
    responseStatus: 400,
    error: 'cash_balance_lower_than_payment_amount',
  },
  {
    endpoint: 'labs/trades/payment/pay_participations',
    method: 'post',
    responseStatus: 400,
    error: 'insufficient_funds',
  },
  {
    endpoint: 'labs/trades/payment/pay_participations',
    method: 'post',
    responseStatus: 409,
    error: 'snapshot_amounts_changed',
  },
  {
    endpoint: 'labs/trades/payment/pay_participations',
    method: 'post',
    responseStatus: 400,
    error: 'amount_above_debit_max_amount',
  },
  {
    endpoint: 'labs/trades/payment/pay_participations',
    method: 'post',
    responseStatus: 403,
    error: 'access_denied_admin_cant_pay_instances',
  },
  {
    endpoint: 'secured/invoices',
    method: 'get',
    responseStatus: 403,
    error: 'access_denied_access_token_incompatible_with_invoice',
  },
];
